import React from "react";
import jquery from "jquery";

import("timezone-picker");
import "../../../css/style_tz_map.scss";
import * as luxon from "luxon";
import {
	current_abbreviation,
	refresh_dropdown_abbreviations,
	refresh_quicklink_abbreviations,
} from "../../tz_abbreviation";

interface TimezonePickerProps {
	updateFunc: Function;
	token_type: string;
	access_token: string;
	guild_id: string;
	current_timezone: string;
	secondary_timezones: string[];
	is_secondary: boolean;
	use_discord_timestamps: boolean;
	saveFunc: Function;
}

interface TimezonePickerState {
	tz_string: string;
}

export class TimezonePickerForm extends React.Component<
	TimezonePickerProps,
	TimezonePickerState
> {
	private el: HTMLDivElement;
	private wrappedEl: any;

	constructor(props) {
		super(props);
		this.state = {
			tz_string: this.props.current_timezone,
		};
	}

	componentDidMount() {
		const initial_this = this;
		const props = this.props;

		function update_set_timezone_button(
			timezone: string,
			disabled: boolean
		) {
			let button_text: string;
			if (!disabled) {
				button_text = `Set timezone to ${timezone}`;
			} else {
				button_text = `${timezone} already set as timezone`;
			}

			jquery(".set-timezone-button").prop("disabled", disabled);
			jquery(".set-timezone-button").prop("innerHTML", button_text);
			//button.innerHTML = text;
		}

		this.wrappedEl = jquery(this.el);

		let map_tz_string: string = null;

		const current_timezone = this.props.current_timezone;
		const secondary_timezones = this.props.secondary_timezones;

		let disabled = true;
		if (this.props.is_secondary) {
			disabled =
				this.props.secondary_timezones.includes(current_timezone);
		}

		update_set_timezone_button(current_timezone, disabled);

		this.wrappedEl.timezonePicker({
			hoverText: function (e, data) {
				return (
					data.timezone + " (" + current_abbreviation(data.timezone) + ")"
				);
			},
			defaultValue: current_timezone,
			quickLink: [
				{
					UTC: "UTC",
					PST: "America/Los_Angeles",
					MST: "America/Denver",
					CST: "America/Chicago",
					EST: "America/New_York",
					UK: "Europe/London",
					GMT: "Africa/Abidjan",
				},
			],
		});

		refresh_dropdown_abbreviations(this.wrappedEl);
		refresh_quicklink_abbreviations(this.wrappedEl);

		const timezonePickerElement = this.wrappedEl;

		const changing_primary = !this.props.is_secondary;

		this.wrappedEl.on("map:value:changed", function () {
			map_tz_string = timezonePickerElement
				.data("timezonePicker")
				.getValue()[0].timezone;

			let disabled = false;
			if (changing_primary) {
				disabled = map_tz_string === current_timezone;
			}

			initial_this.setState({
				tz_string: map_tz_string ?? props.current_timezone,
			});

			disabled = disabled || secondary_timezones.includes(map_tz_string);

			update_set_timezone_button(map_tz_string, disabled);
		});
	}

	componentWillUnmount() {
		//this.wrappedEl.timezonePicker("destroy");
	}

	handleChange() {
		this.props.saveFunc(this.state.tz_string);
	}

	render() {
		return (
			<section className="hero">
				<div className="info-area has-text-centered">
					<h1 className="title is-3 result-text">
						{this.props.is_secondary
							? "Click below to add a display timezone"
							: "Click below to set your server's timezone"}
					</h1>
					<p className="is-size-5 secondary-text"></p>
				</div>
				<div className="columns is-centered">
					<div
						className="timezone-picker column is-11 is-9-fullhd"
						ref={(el) => (this.el = el)}
					></div>
				</div>
				<div className="columns is-mobile is-centered">
					<div className="column is-full-mobile is-three-quarters-tablet is-5-desktop">
						<div className="columns is-mobile is-centered">
							<div className="column">
								<button
									className="set-timezone-button button dashboard-primary-button is-size-4-tablet is-size-5-mobile"
									onClick={() => this.handleChange()}
								>
									Set timezone
								</button>
							</div>
						</div>
					</div>
				</div>
			</section>
		);
	}
}
